import { Component } from "@angular/core";
import {AdminLayoutStandardComponent} from "../standard/standard.component";

@Component({
  selector: "admin-layout-minimal",
  templateUrl: "./minimal.component.html",
  styleUrls: ["./minimal.component.css"]
})
export class AdminLayoutMinimalComponent {

}
